import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { Link, useParams } from "react-router-dom";
import { Footer, Navbar } from "../components";
import axios from "axios";
import configData from "../config.json";

const CSCenterPage=()=>{
    const { id } = useParams();
    const [csCenter,setcsCenter]=useState([]);
   

    useEffect(() => {
        const getcsCenter = async () => {
        const response=await axios.get(configData.SERVER_URL+'/enterprises')
          setcsCenter(response.data);
        };
        getcsCenter();
    }, []);

    return(
        <>
        <Navbar/>
        <div className="container my-3 py-3">
        <div className="hero border-1 pb-3">
            <div className="card bg-dark text-white border-0 mx-3">
                <img className="card-img img-fluid" 
                src={configData.IMAGE_URL+"/onestop.png"}
                alt="Card" height={500}/>
                <div class="col-12 text-center">
                    <h3>Welcome to Customer Support Center</h3>             
                    <h1 ><span class="fa fa-phone fa-1x"></span>02-55012759, 01701276958</h1>
                    <h5 >Open: 09:00 AM - 04:00 PM (Except Offdays and Holidays)</h5>
                </div>
            </div>
            <hr/>
            <div className="row justify-content-center">
          {
            csCenter && csCenter.length>0 && csCenter.map((i)=> 
            <div className="col-md-3 col-sm-6 mb-3 px-3">
            <div className="card h-100">
              <img className="card-img-top img-fluid" src={configData.IMAGE_URL+'/companies/'+i.logo}  alt="" style={{width:100}} />
              <div className="card-body">
                <h5 className="card-title" style={{color: "green"}}>{i.branchName}</h5>
                <h6 style={{color: "red"}}>{i.hotlineNo}</h6>
                <h6>{i.webaddress}</h6>
              </div>
            </div>
            </div>
            )
          }

            </div>
        </div>

        </div>
        <Footer/>
        </>
    )  
}

export default CSCenterPage;